import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isHelixAndLearningHub } from 'utils/helix';
import { useFetchUserAnalysisSkillsContent } from 'actions/users';
import Heading from 'components/Heading';
import Flex from 'components/Flex';
import RelatedSkillContentButton from './RelatedSkillContentButton';
import SkillContentList from './SkillContentList';
function SkillContentSection(_ref) {
  var isCurrentUser = _ref.isCurrentUser,
    name = _ref.name,
    userId = _ref.userId,
    skillId = _ref.skillId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFetchUserAnalysis = useFetchUserAnalysisSkillsContent({
      userId: userId,
      skillId: skillId,
      enabled: isHelixAndLearningHub
    }),
    linkedContent = _useFetchUserAnalysis.items,
    isError = _useFetchUserAnalysis.isError,
    isLoading = _useFetchUserAnalysis.isLoading;
  var hasContent = (linkedContent === null || linkedContent === void 0 ? void 0 : linkedContent.length) > 0;
  return /*#__PURE__*/React.createElement("section", {
    "aria-labelledby": "recommended-content"
  }, /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "space-between",
    alignItems: "baseline"
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h3",
    size: "small",
    mb: "s",
    id: "recommended-content"
  }, t('skills_title_recommended_content')), hasContent && /*#__PURE__*/React.createElement(RelatedSkillContentButton, {
    name: name
  })), /*#__PURE__*/React.createElement(SkillContentList, {
    isCurrentUser: isCurrentUser,
    skillName: name,
    isLoading: isLoading,
    isError: isError,
    linkedContent: linkedContent
  }));
}
export default SkillContentSection;